import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { Collaborator } from 'src/app/models/collaborator';
import { EnderecoCep, EnderecoCidade } from 'src/app/models/endereco';
import { AddressKyc, KycValidations, PersonAddress, PersonDocument, PersonFiles, PersonPicture } from 'src/app/models/kyc';
import { BindRequest, ValidatePanResponse } from 'src/app/models/physical-card';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { KycService } from 'src/app/services/kyc.service';
import { PhysicalCardService } from 'src/app/services/physical-card.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { KycType } from 'src/app/shared/enums/kyc.enum';

@Component({
  selector: 'app-colaborador-vincular-cartao-form',
  templateUrl: './colaborador-vincular-cartao-form.component.html',
  styleUrls: ['./colaborador-vincular-cartao-form.component.css']
})
export class ColaboradorVincularCartaoFormComponent implements OnInit, AfterViewInit {
    @ViewChild('stepper') public cardStepper: MatStepper;

    private currentUser: Auth;
    public collaborator: Collaborator;

    private addressCEP: EnderecoCep;
    private enderecoCidade: EnderecoCidade[];
    emptyCity: boolean = true;
    emptyUf: boolean = true;

    personalDataFormGroup: FormGroup;
    cardDataFormGroup: FormGroup;

    public MASKS = MASKS;
    cardmask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ];
    datemask = [/\d/, /\d/, '/', /\d/, /\d/];
    //myModel.replace(/\D+/g, '') - remover mascara

    private personAddress: PersonAddress;
    private personPicture: PersonPicture;
    private personDocument: PersonDocument;
    private personFiles: PersonFiles;
    uploadAddressOk: any;
    uploadPersonPictureOk: any;
    uploadPersonDocumentOk: any;
    uploadPersonFilesOk: any;

    public personPictureFile: string;
    public principalAttachmentFile: string;
    public auxiliarAttachmentFile: string;
    public accept = ['png','jpg','jpeg'];
    showErrorPersonPicture: boolean = false;
    showErrorAuxAttachment: boolean = false;
    showErrorPrincipalAttachment: boolean = false;

    kycPhysicalCard: KycValidations;
    validatedPanRes: ValidatePanResponse;
    isValidPan: boolean;
    showErrorPan: boolean = false;
    bindRequest: BindRequest;
    canBindNewUser: boolean;
    showErrorBindNewUser: boolean;
    bindcard: boolean = false;
    psCardId: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private authenticationService: AuthenticationService,
        private addressService: EnderecoService,
        private kycService: KycService,
        private physicalCardService: PhysicalCardService,
    ) { }
    public ngAfterViewInit(): void
    {
        setTimeout(() => {
            if(this.collaborator.kycValidations != null){
                this.kycPhysicalCard = this.collaborator.kycValidations.find(x=>x.kycTypeId == KycType.PhysicalCard);
                if(this.kycPhysicalCard.kycValidated){
                    this.cardStepper.selected.editable = false;
                    this.cardStepper.selected.completed = true;
                    this.cardStepper.next();
                }
            }
        });
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.collaborator = JSON.parse(sessionStorage.getItem('currentCollaborator'));
        this.createForm();
    }

    private createForm() {
        this.personalDataFormGroup = this._formBuilder.group({
            cep: new FormControl(null, [
                Validators.required,
                //Validators.maxLength(9),
                NgBrazilValidators.cep
            ]),
            address: new FormControl(null, [
                Validators.maxLength(500),
                Validators.required
            ]),
            number: new FormControl(null, [
                Validators.maxLength(10),
                Validators.required
            ]),
            complement: new FormControl(null, [
                Validators.maxLength(50)
            ]),
            neighborhood: new FormControl(null, [
                Validators.maxLength(200),
                Validators.required
            ]),
            city: new FormControl(null, [
                Validators.required
            ]),
            uf: new FormControl(null, [
                Validators.required,
            ])
        });
        this.cardDataFormGroup = this._formBuilder.group({
            cardNumber: new FormControl(null, [
                Validators.required
            ]),
            cvv: new FormControl(null, [
                Validators.maxLength(3),
                Validators.required
            ]),
            expirationDate: new FormControl(null, [
                Validators.required
            ])
        });

    }

    getAddress(cep: string) {
        if (this.personalDataFormGroup.get('cep').valid && this.personalDataFormGroup.get('cep').value !== null) {
            this.addressService.getCEP(cep.replace(/\D+/g, '')).subscribe(
                response => {
                    this.addressCEP = response.result;
                    if(this.addressCEP.uf == null || this.addressCEP.cidade == null){
                        this.emptyUf = false;
                        this.emptyCity = false;
                    }
                    this.setAddress(this.addressCEP);

                }, error => {
                    this.alertService.error('CEP não localizado!');
                }
            );

        }
    }

    setAddress(enderecoCEP?: EnderecoCep) {
        if (enderecoCEP) {
            this.getCity(enderecoCEP.uf);
            this.personalDataFormGroup.patchValue({
                address: enderecoCEP.logradouro,
                neighborhood: enderecoCEP.bairro,
                city: enderecoCEP.cidade,
                uf: enderecoCEP.uf,
                cep: enderecoCEP.cep
            });
        } else {
            return;
        }

    }

    getCity(uf: string) {
        if(uf == null || uf.replace(/\s/g,'') === '')
            uf = null;

        if (uf) {
            this.addressService.getCidade(uf).subscribe(
                response => {
                    this.enderecoCidade = response.result;
                },
                error => {
                    this.alertService.error('Não foi possível carregar as cidades');
                }
            );
        }
    }

    setFile(file: any,index: number): void {
        switch(index){
            case 1:
                this.personPictureFile = file;
                this.showErrorPersonPicture = false;
                break;
            case 2:
                this.principalAttachmentFile = file;
                this.showErrorPrincipalAttachment = false;
                break;
            case 3:
                this.auxiliarAttachmentFile = file;
                this.showErrorAuxAttachment = false;
                break;
        }
        //this.file = file;

        if (!file) {
          this.alertService.error('Formato de arquivo não suportado!');
          this.alertService.error('Formatos aceitos: PNG, JPEG');
        }
      }

    async uploadAddress() {
        this.personAddress = new PersonAddress();
        this.personAddress.assignorGuid = this.currentUser.token.assignorGuid;
        this.personAddress.managerGuid = this.currentUser.token.userReferenceId;
        this.personAddress.personGuid = this.collaborator.personGuid;
        if(!this.personalDataFormGroup.valid){
            return false;
        }
        this.personAddress.personAddress = new AddressKyc();
        this.personAddress.personAddress.zipCode = this.personalDataFormGroup.get('cep').value.replace(/\D+/g, '');
        this.personAddress.personAddress.addressName = this.personalDataFormGroup.get('address').value;
        this.personAddress.personAddress.number = parseInt(this.personalDataFormGroup.get('number').value).toString();
        this.personAddress.personAddress.complement = this.personalDataFormGroup.get('complement').value;
        this.personAddress.personAddress.neighborhood = this.personalDataFormGroup.get('neighborhood').value;
        this.personAddress.personAddress.city = this.personalDataFormGroup.get('city').value;
        this.personAddress.personAddress.uf = this.personalDataFormGroup.get('uf').value;
        this.uploadAddressOk = await this.kycService.uploadAddress(this.personAddress).toPromise()
            .then(response => {
                    let res = response;
                    if(res.status == ApiError.Sucesso){
                        return true;
                    }
                    else{
                        this.alertService.error(response.message)
                        return false;
                    }
                }
            ).catch(error => {this.alertService.error("Não foi possível adicionar o endereço!"); console.log(error)})
    }

    async uploadPersonPicture() {
        this.personPicture = new PersonPicture();
        this.personPicture.assignorGuid = this.currentUser.token.assignorGuid;
        this.personPicture.managerGuid = this.currentUser.token.userReferenceId;
        this.personPicture.personGuid = this.collaborator.personGuid;
        const personPictureImg = this.personPictureFile;
        if (!personPictureImg) {
            this.alertService.error('Nenhuma foto do rosto escolhida!');
            return false;
        }
        const imageFormat = this.personPictureFile.split(';')[0].replace("data:","");
        this.personPicture.format = imageFormat;
        this.personPicture.personPicture = personPictureImg.replace(/^data:image\/[a-z]+;base64,/, "");

        this.uploadPersonPictureOk = await this.kycService.uploadPersonPicture(this.personPicture).toPromise()
            .then(response => {
                    let res = response;
                    if(res.status == ApiError.Sucesso){
                        return true;
                    }
                    else{
                        this.alertService.error(response.message)
                        return false;
                    }
                }
            ).catch(error => {this.alertService.error("Não foi possível adicionar a foto do rosto!"); console.log(error)})
    }

    async uploadPersonDocument(){
        this.personDocument = new PersonDocument();
        this.personDocument.assignorGuid = this.currentUser.token.assignorGuid;
        this.personDocument.managerGuid = this.currentUser.token.userReferenceId;
        this.personDocument.personGuid = this.collaborator.personGuid;
        const principalAttachmentImg = this.principalAttachmentFile;
        const auxiliarAttachmentImg = this.auxiliarAttachmentFile;
        if (!principalAttachmentImg) {
            this.alertService.error('Nenhuma foto da frente do documento escolhida!');
            return false;
        }
        if (!auxiliarAttachmentImg) {
            this.alertService.error('Nenhuma foto do verso do documento escolhida!');
            return false;
        }
        const imageFormat = this.principalAttachmentFile.split(';')[0].replace("data:","");
        this.personDocument.format = imageFormat;
        this.personDocument.principalAttachment = principalAttachmentImg.replace(/^data:image\/[a-z]+;base64,/, "");;
        this.personDocument.auxiliarAttachment = auxiliarAttachmentImg.replace(/^data:image\/[a-z]+;base64,/, "");;

        this.uploadPersonDocumentOk = await this.kycService.uploadPersonDocument(this.personDocument).toPromise()
            .then(response => {
                    let res = response;
                    if(res.status == ApiError.Sucesso){
                        return true;
                    }
                    else{
                        this.alertService.error(response.message)
                        return false;
                    }
                },
            ).catch(error => {this.alertService.error("Não foi possível adicionar os documentos!"); console.log(error)})
    }

    async UploadFiles(){

        this.personFiles = new PersonFiles();
        this.personFiles.assignorGuid = this.currentUser.token.assignorGuid;
        this.personFiles.managerGuid = this.currentUser.token.userReferenceId;
        this.personFiles.personGuid = this.collaborator.personGuid;

        if(!this.personalDataFormGroup.valid){
            return false;
        }
        this.personFiles.personAddress = new AddressKyc();
        this.personFiles.personAddress.zipCode = this.personalDataFormGroup.get('cep').value.replace(/\D+/g, '');
        this.personFiles.personAddress.addressName = this.personalDataFormGroup.get('address').value;
        this.personFiles.personAddress.number = parseInt(this.personalDataFormGroup.get('number').value).toString();
        this.personFiles.personAddress.complement = this.personalDataFormGroup.get('complement').value;
        this.personFiles.personAddress.neighborhood = this.personalDataFormGroup.get('neighborhood').value;
        this.personFiles.personAddress.city = this.personalDataFormGroup.get('city').value;
        this.personFiles.personAddress.uf = this.personalDataFormGroup.get('uf').value;

        const personPictureImg = this.personPictureFile;
        const principalAttachmentImg = this.principalAttachmentFile;
        const auxiliarAttachmentImg = this.auxiliarAttachmentFile;
        if (!personPictureImg) {
            this.alertService.error('Nenhuma foto do rosto escolhida!');
            return false;
        }
        if (!principalAttachmentImg) {
            this.alertService.error('Nenhuma foto da frente do documento escolhida!');
            return false;
        }
        if (!auxiliarAttachmentImg) {
            this.alertService.error('Nenhuma foto do verso do documento escolhida!');
            return false;
        }
        const personPictureFormat = this.personPictureFile.split(';')[0].replace("data:","");
        const principalAttachmentFormat = this.principalAttachmentFile.split(';')[0].replace("data:","");
        const auxiliarAttachmentFormat = this.auxiliarAttachmentFile.split(';')[0].replace("data:","");

        this.personFiles.personPicture = personPictureImg.replace(/^data:image\/[a-z]+;base64,/, "");
        this.personFiles.principalAttachment = principalAttachmentImg.replace(/^data:image\/[a-z]+;base64,/, "");
        this.personFiles.auxiliarAttachment = auxiliarAttachmentImg.replace(/^data:image\/[a-z]+;base64,/, "");
        this.personFiles.personPictureFormat = personPictureFormat;
        this.personFiles.principalAttachmentFormat = principalAttachmentFormat;
        this.personFiles.auxiliarAttachmentFormat = auxiliarAttachmentFormat;

        this.uploadPersonFilesOk = await this.kycService.uploadFiles(this.personFiles).toPromise()
            .then(response => {
                    let res = response;
                    if(res.status == ApiError.Sucesso){
                        return true;
                    }
                    else{
                        this.alertService.error(response.message)
                        return false;
                    }
                },
            ).catch(error => {this.alertService.error("Não foi possível adicionar os documentos!"); console.log(error)})

    }

    async goForward(stepper: MatStepper){
        const personPictureImg = this.personPictureFile;
        const principalAttachmentImg = this.principalAttachmentFile;
        const auxiliarAttachmentImg = this.auxiliarAttachmentFile;
        let errorimg = false;
        if (!personPictureImg) {
            this.showErrorPersonPicture = true;
            this.alertService.error('Nenhuma foto do rosto escolhida!');
            errorimg = true;
        }
        if (!principalAttachmentImg) {
            this.showErrorPrincipalAttachment = true;
            this.alertService.error('Nenhuma foto da frente do documento escolhida!');
            errorimg = true;
        }
        if (!auxiliarAttachmentImg) {
            this.showErrorAuxAttachment = true;
            this.alertService.error('Nenhuma foto do verso do documento escolhida!');
            errorimg = true;
        }
        if(errorimg)
            return false;

        //await this.uploadAddress();
        //await this.uploadPersonPicture();
        //await this.uploadPersonDocument();
        // if(this.uploadAddressOk && this.uploadPersonPictureOk && this.uploadPersonDocumentOk){
        //     stepper.selected.editable = false;
        //     stepper.selected.completed = true;
        //     stepper.next();
        // }
        await this.UploadFiles();
        if(this.uploadPersonFilesOk){
            stepper.selected.editable = false;
            stepper.selected.completed = true;
            stepper.next();
        }
    }

    getPan(pan: string){
        if (this.cardDataFormGroup.get('cardNumber').valid && this.cardDataFormGroup.get('cardNumber').value !== null) {
            this.physicalCardService.validatePan(pan.replace(/\D+/g, '')).subscribe(
                response => {
                    this.validatedPanRes = response.result;

                    this.isValidPan = this.validatedPanRes.isValidPan;
                    this.showErrorPan = !this.isValidPan;
                    this.canBindNewUser = this.validatedPanRes.canBindNewUser;
                    this.showErrorBindNewUser = !this.canBindNewUser;
                    this.bindcard = this.isValidPan;

                    this.psCardId = this.validatedPanRes.psCardId;
                }, error => {
                    this.alertService.error('CEP não localizado!');
                }
            );
        }
    }

    bindCard(stepper: MatStepper){
        if(this.cardDataFormGroup.valid){

            this.bindRequest = new BindRequest;
            this.bindRequest.assignorGuid = this.currentUser.token.assignorGuid;
            this.bindRequest.managerGuid = this.currentUser.token.userReferenceId;
            this.bindRequest.personGuid = this.collaborator.personGuid;
            this.bindRequest.psCardId = this.psCardId;
            this.bindRequest.pan = this.cardDataFormGroup.get('cardNumber').value.replace(/\D+/g, '');
            this.bindRequest.cvv = this.cardDataFormGroup.get('cvv').value;
            this.bindRequest.validityDate = this.cardDataFormGroup.get('expirationDate').value;

            this.physicalCardService.bindCard(this.bindRequest).subscribe(
                response => {
                    if(response.status == ApiError.Sucesso){
                        stepper.selected.editable = false;
                        stepper.selected.completed = true;
                        stepper.next();
                    }
                    else{
                        this.alertService.error(response.message);
                    }
                }
            )
        }
    }

    redirectList(){
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }
}
